// extracted by mini-css-extract-plugin
export default {"zoom":"Toa-z","zoomContent":"Uoa-z"};